<!--
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<!-- TEST -->
<template>
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
  <!-- Full-viewport width (above sidenav), matching BizAssure portal -->
  <platform-billing-payment-banner v-if="!isMinimalAuthLayout" />
  <sidenav v-if="showSidenav && !isMinimalAuthLayout" />
  <main class="main-content position-relative max-height-vh-100 h-100">
    <navbar v-if="showNavbar && !isMinimalAuthLayout" />
    <router-view />
    <app-footer v-show="showFooter && !isMinimalAuthLayout" />

    <!-- Updated dynamic modal with new props -->
    <dynamic-modal
      :is-visible="showModalFlag"
      :modal-type="modalType"
      :modal-title="modalTitle"
      :modal-events="modalEvents"
      :modal-date="modalDate"
      :modal-position="modalPosition"
      @close="triggerHideModal"
    />
    <global-spinner />
  </main>
</template>

<script>
import Sidenav from "./examples/Sidenav";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import DynamicModal from "@/components/DynamicModal.vue";
import GlobalSpinner from "@/components/GlobalSpinner.vue";
import PlatformBillingPaymentBanner from "@/components/PlatformBillingPaymentBanner.vue";

import { mapState, mapActions } from "vuex";
import { isPublicAuthPath } from "@/utils/public-auth-routes";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    AppFooter,
    DynamicModal,
    GlobalSpinner,
    PlatformBillingPaymentBanner,
  },
  data() {
    return {
      modalType: 'event', // default modal type
      modalTitle: 'Event Details',
    };
  },
  computed: {
    ...mapState('modal', [
      'showModalFlag',
      'modalEvents',
      'modalDate',
      'modalPosition'
    ]),
    ...mapState([
      "layout",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton"
    ]),
    ...mapState("auth", ["isAuthenticated"]),
    isMinimalAuthLayout() {
      return isPublicAuthPath(this.$route?.path || "");
    },
  },
  watch: {
    isAuthenticated(value) {
      if (value) {
        this.refreshBillingStatus();
      } else {
        this.$store.dispatch("agencyBilling/clear");
      }
    },
    "$store.getters['profile/role']"(role) {
      if (this.isAuthenticated && role === "agency_admin") {
        this.refreshBillingStatus();
      }
    },
    // SSO lands on /sso then navigates into the app — refresh once chrome appears
    isMinimalAuthLayout(isMinimal, wasMinimal) {
      if (wasMinimal && !isMinimal && this.isAuthenticated) {
        this.refreshBillingStatus();
      }
    },
  },
  methods: {
    ...mapActions('modal', ['hideModal']),
    triggerHideModal() {
      this.hideModal();
    },
    showTaskModal() {
      this.modalType = 'task';
      this.modalTitle = 'Select a Task';
      this.showModalFlag = true;
    },
    refreshBillingStatus() {
      this.$store.dispatch("agencyBilling/refresh", { force: true }).catch(() => null);
    },
  },
  async mounted() {
    if (this.isAuthenticated && !this.isMinimalAuthLayout) {
      try {
        await this.$store.dispatch("profile/me");
      } catch (error) {
        // ignore — auth middleware / login flow will handle
      }
      this.refreshBillingStatus();
    }
    (function(c, s, q, u, a, r, e) {
      c.hj = c.hj || function() {
        (c.hj.q = c.hj.q || []).push(arguments);
      };
      c._hjSettings = { hjid: a };
      r = s.getElementsByTagName('head')[0];
      e = s.createElement('script');
      e.async = true;
      e.src = q + c._hjSettings.hjid + u;
      r.appendChild(e);
    })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', 5196653);
  },
};
</script>
<style>
.shepherd-element {
  z-index: 99999 !important;
}
.shepherd-modal-overlay-container {
  z-index: 99998 !important;
}
</style>
